module.exports = __webpack_public_path__ + "static/media/successCheckboxV2.577f26af.svg";